import { VariantProps, tv } from '@/utils/tv'

export const gallery = tv({
  slots: {
    base: ['relative', 'overflow-hidden', 'bg-gray-100', 'py-10 md:py-20'],
    container: ['container-fluid', 'max-w-[93%]', 'relative'],
    heading: ['mb-6 sm:mb-10'],
    title: [],
    galleryWrapper: ['relative'],
    gallery: ['relative z-20', '!overflow-visible'],
    item: ['bg-white', 'p-8 md:px-28 md:py-24'],
    figure: ['aspect-16/6'],
    cover: ['object-contain object-center'],
    arrow: ['absolute z-30 inset-y-0', 'my-auto', 'shadow-lg']
  }
})

export type GalleryVariantProps = VariantProps<typeof gallery>

export type GalleryReturnVariantProps = ReturnType<typeof gallery>
